import { useEffect, useRef, useState } from 'react';
import { authAPI } from '../../../../services/redwolfSdkAPI';
import { customerSupportAPI } from '../../../../services/redwolfSdkAPI';
import useRequestRedwolfService from '../../../common/hooks/useRequestRedwolfService';
import { addClasses } from '../../../../utils/eventListeners';
import useMobileView from '../../../../components/common/hooks/useMobileView';
import { useGoogleAnalytics } from '../../../common/hooks/useGoogleAnalytics';
import useTechnicalErrorMessage from '../../../common/hooks/useTechnicalErrorMessage';
import { notification, isMobile } from '../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../common/components/Modal';
import * as Sentry from '@sentry/react';
import { getToken } from '../../../../utils/localStorage';
import Spinner from '../../../common/components/Spinner';
import { openNotification } from '../../../../store/commonSlice';
import { getHoursFromString } from '../../../../utils/commonFunctions';
import { checkEmailFormat, checkNameFormat } from '../../../../utils/validations';
import { setUserProfile, UserProfile } from '../../../../store/userSlice';
import { initiateSupportChat, sfPreChatData } from '../../../../services/salesforce_chat';

interface supportHoursModal {
	chatWeekdayBegin: string;
	chatWeekdayEnd: string;
	chatWeekendBegin: string;
	chatWeekendEnd: string;
	phoneNumberEnglish: string;
	phoneNumberSpanish: string;
	phoneWeekdayBegin: string;
	phoneWeekdayEnd: string;
	phoneWeekendBegin: string;
	phoneWeekendEnd: string;
	smsNumber: string;
	timeZone: string;
	waitTimeMessage: string;
}
const modelOrSerialNumberDisplay: any = 'input-hidden';
const WebSupport = (props: any) => {
	const [logGoogleAnalyticsEvent] = useGoogleAnalytics();
	const [requestRedwolfService] = useRequestRedwolfService();
	const [showTechnicalErrorMessage] = useTechnicalErrorMessage();
	const [isSpinnerLoading, setIsSpinnerLoading] = useState(false);
	//const [isSupportModalOpen, setSupportModalOpen] = useState(false);
	const [supportCallMeModalOpen, setSupportCallMeModalOpen] = useState(false);
	const [supportTextMeModalOpen, setSupportTextMeModalOpen] = useState(false);
	// const [isModalDeviceModalNumber, setModalDeviceModalNumber] = useState<string | null>(null);
	// const [isModalDeviceSerialNumber, setModalDeviceSerialNumber] = useState<string | null>(null);
	const [modelNumberShow, setModelNumberShow] = useState(false);
	const [successModalOpen, setSuccessModalOpen] = useState(false);
	const [labelOptional, setLabelOptional] = useState(true);
	const [callMeText, setCallMeText] = useState(false);
	const [chatNowText, setChatNowText] = useState(false);
	const [serialModalOpen, setSerialModalOpen] = useState(false);
	//const [registerProducts, setRegisterProducts]: any = useState([]);
	//const [showElement, setShowElement] = useState(true);
	//const [selectedOption, setSelectedOption] = useState(null);
	const [supportHours, setSupportHours] = useState<supportHoursModal>();
	const [isSupportOffline, setSupportOffline] = useState<boolean>(false);
	const [formErrorMessages, setFormErrorMessages] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phoneNo: '',
		modelOrSerialNumber: '',
		modelNumber: '',
		serialNumber: '',
		notes: ''
	});
	const [contactInformationForm, setContactInformationForm] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phoneNo: '',
		modelOrSerialNumber: '',
		modelNumber: '',
		serialNumber: '',
		notes: ''
	});
	const [isSetUpdateMyAccount, setISSetUpdateMyAccount] = useState(false);
	const firstNameRef = useRef<HTMLInputElement>(null);
	const lastNameRef = useRef<HTMLInputElement>(null);
	const emailRef = useRef<HTMLInputElement>(null);
	const phoneRef = useRef<HTMLInputElement>(null);
	const notesRef = useRef<HTMLTextAreaElement>(null);
	const modelOrSerialNumberRef = useRef<HTMLInputElement>(null);
	const supportContainerFocusRef: any = useRef<HTMLDivElement>(null);
	const supportTabindex = !isMobile ? { tabIndex: -1 } : {};
	const [isMobileView] = useMobileView();
	const {
		account: { user },
		userProfile
	} = useSelector((state: any) => state.user);
	let isUserInfoUpdated = false;
	const reformatPhoneNumber =
		user && user.phoneNumber && user.phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

	Sentry.startInactiveSpan({ name: 'Devices' });

	const dispatch = useDispatch();
	const token = getToken();

	useEffect(() => {
		addClasses();

		if (supportContainerFocusRef.current) {
			supportContainerFocusRef.current.focus();
		}
	}, []);

	useEffect(() => {
		getCustomerSupportHours();
	}, []);
	useEffect(() => {
		if (user) {
			setContactInformationForm({
				firstName: user && user.firstName,
				lastName: user && user.lastName,
				email: user && user.email && user.email !== 'null' ? user.email : '',
				phoneNo: reformatPhoneNumber && reformatPhoneNumber,
				modelOrSerialNumber: '',
				modelNumber: '',
				serialNumber: '',
				notes: ''
			});
		}
	}, [user]);
	const handleCallMeModalOpen = () => {
		props.closeModal();
		setSupportCallMeModalOpen(true);
		setModelNumberShow(true);
		setChatNowText(false);
		setCallMeText(true);
		setLabelOptional(true);
		if (props.updateSupportModalToggle) {
			props.updateSupportModalToggle(false, true);
			if (props.isModalDeviceModalNumber || props.isModalDeviceSerialNumber) {
				props.updateSupportModalToggle(false, false);
			}
		}
	};
	const handleTextMeModalOpen = () => {
		logGoogleAnalyticsEvent('VizioSupport_Sendtext');
		props.closeModal();
		setSupportCallMeModalOpen(false);
		setSupportTextMeModalOpen(true);
	};
	const handleChatModalOpen = () => {
		props.closeModal();
		setSupportCallMeModalOpen(true);
		setSupportTextMeModalOpen(false);
		setModelNumberShow(true);
		setChatNowText(true);
		setCallMeText(false);
		setLabelOptional(false);
		if (props.updateSupportModalToggle) {
			props.updateSupportModalToggle(false, true);
			if (props.isModalDeviceModalNumber || props.isModalDeviceSerialNumber) {
				props.updateSupportModalToggle(false, false);
			}
		}
		setContactInformationForm({
			firstName: user && user.firstName,
			lastName: user && user.lastName,
			email: user && user.email && user.email !== 'null' ? user.email : '',
			phoneNo: reformatPhoneNumber && reformatPhoneNumber,
			modelOrSerialNumber: '',
			modelNumber: '',
			serialNumber: '',
			notes: ''
		});
	};
	const getCustomerSupportHours = () => {
		requestRedwolfService(customerSupportAPI.getSupportHours())
			.then((response: any) => {
				if (response.constructor.$metadata$.simpleName === 'Success' && response.data) {
					const supportHoursData = response.data;
					const resultHours: supportHoursModal = {
						chatWeekdayBegin: supportHoursData.chatWeekdayBegin,
						chatWeekdayEnd: supportHoursData.chatWeekdayEnd,
						chatWeekendBegin: supportHoursData.chatWeekendBegin,
						chatWeekendEnd: supportHoursData.chatWeekendEnd,
						phoneNumberEnglish: supportHoursData.phoneNumberEnglish,
						phoneNumberSpanish: supportHoursData.phoneNumberSpanish,
						phoneWeekdayBegin: supportHoursData.phoneWeekdayBegin,
						phoneWeekdayEnd: supportHoursData.phoneWeekdayEnd,
						phoneWeekendBegin: supportHoursData.phoneWeekendBegin,
						phoneWeekendEnd: supportHoursData.phoneWeekendEnd,
						smsNumber: supportHoursData.smsNumber,
						timeZone: supportHoursData.timeZone,
						waitTimeMessage: supportHoursData.waitTimeMessage
					};
					setSupportHours(resultHours);
					checkIfSupportIsOffline(resultHours);
				} else {
					dispatch(
						openNotification({
							type: 'ERROR',
							heading: 'Error',
							body: 'Unable to fetch Hours of Support, Please try again later'
						})
					);
				}
			})
			.catch((err: any) => {
				showTechnicalErrorMessage();
				console.error(err);
			});
	};
	const checkIfSupportIsOffline = (chatSupportHours: supportHoursModal) => {
		if (chatSupportHours) {
			const currentDate = new Date(
				new Date().toLocaleString('en', { timeZone: 'America/Chicago' })
			);
			const currentDay = currentDate.getDay();
			let supportStartTime: Date, supportEndTime: Date;

			if (currentDay >= 1 && currentDay <= 5) {
				supportStartTime = getHoursFromString(chatSupportHours?.chatWeekdayBegin);
				supportEndTime = getHoursFromString(chatSupportHours?.chatWeekdayEnd);
			} else {
				supportStartTime = getHoursFromString(chatSupportHours?.chatWeekendBegin);
				supportEndTime = getHoursFromString(chatSupportHours?.chatWeekendEnd);
			}
			supportStartTime.getTime() <= currentDate.getTime() &&
			currentDate.getTime() <= supportEndTime.getTime()
				? setSupportOffline(false)
				: setSupportOffline(true);
		}
	};
	const handleSupportCallMeModalHide = () => {
		setFormErrorMessages({
			firstName: '',
			lastName: '',
			email: '',
			phoneNo: '',
			modelOrSerialNumber: '',
			modelNumber: '',
			serialNumber: '',
			notes: ''
		});
		setContactInformationForm({
			firstName: user && user.firstName,
			lastName: user && user.lastName,
			email: user && user.email && user.email !== 'null' ? user.email : '',
			phoneNo: reformatPhoneNumber && reformatPhoneNumber,
			modelOrSerialNumber: '',
			modelNumber: '',
			serialNumber: '',
			notes: ''
		});
		if (modelOrSerialNumberRef.current) {
			modelOrSerialNumberRef.current.classList.remove('active');
		}
		setSupportCallMeModalOpen(false);
	};
	const handleChange = (event: any) => {
		const { name, value } = event.target;
		const contactInformation = { ...contactInformationForm, [name]: value };
		setFormErrorMessages({ ...formErrorMessages, [name]: '' });

		if (name === 'phoneNo' && value.length < 15) {
			let formattedPhoneNumber = value.replace(/[^\d]/g, '');
			const cursorPosition = event.target.selectionStart;
			if (formattedPhoneNumber.length === 0) {
				formattedPhoneNumber = '';
			} else if (formattedPhoneNumber.length > 0 && formattedPhoneNumber.length < 4) {
				formattedPhoneNumber = `(${formattedPhoneNumber}`;
			} else if (formattedPhoneNumber.length > 3 && formattedPhoneNumber.length < 7) {
				formattedPhoneNumber = `(${formattedPhoneNumber.slice(0, 3)}) ${formattedPhoneNumber.slice(
					3,
					6
				)}`;
			} else if (formattedPhoneNumber.length >= 7) {
				formattedPhoneNumber = `(${formattedPhoneNumber.slice(0, 3)}) ${formattedPhoneNumber.slice(
					3,
					6
				)}-${formattedPhoneNumber.slice(6, 10)}`;
			}

			if (value[cursorPosition]) {
				setTimeout(() => {
					phoneRef.current && phoneRef.current.setSelectionRange(cursorPosition, cursorPosition);
				}, 0);
			}
			if (
				event.nativeEvent.inputType !== 'deleteContentBackward' &&
				value[cursorPosition] === ')'
			) {
				setTimeout(() => {
					phoneRef.current &&
						phoneRef.current.setSelectionRange(cursorPosition + 2, cursorPosition + 2);
				}, 0);
			}
			if (
				event.nativeEvent.inputType !== 'deleteContentBackward' &&
				(value[cursorPosition] === '(' || value[cursorPosition] === '-')
			) {
				setTimeout(() => {
					phoneRef.current &&
						phoneRef.current.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
				}, 0);
			}
			if (
				event.nativeEvent.inputType === 'deleteContentBackward' ||
				event.nativeEvent.inputType === 'deleteContentForward'
			) {
				setTimeout(() => {
					phoneRef.current && phoneRef.current.setSelectionRange(cursorPosition, cursorPosition);
				}, 0);
			}

			contactInformation.phoneNo = formattedPhoneNumber;
		}
		setContactInformationForm({ ...contactInformation });
	};

	const handleKeyDown = (event: any) => {
		const { name, value, selectionStart, selectionEnd } = event.target;
		const RegexNumberSpace = /^[0-9\s]+$/i;
		const RegexNumber = /^[0-9]+$/i;

		if ((name === 'firstName' || name === 'lastName') && !checkNameFormat(event.key)) {
			event.preventDefault();
		} else if (
			name === 'phoneNo' &&
			event.keyCode === 8 &&
			'-() '.includes(value[selectionStart - 1]) &&
			value[selectionStart]
		) {
			phoneRef.current &&
				phoneRef.current.setSelectionRange(selectionStart - 1, selectionStart - 1);
			event.preventDefault();
		} else if (
			name === 'phoneNo' &&
			event.keyCode === 8 &&
			'-() '.includes(value[selectionStart]) &&
			RegexNumberSpace.test(value[selectionEnd])
		) {
			phoneRef.current && phoneRef.current.setSelectionRange(selectionStart, selectionStart);
			event.preventDefault();
		} else if (
			name === 'phoneNo' &&
			'-() '.includes(value[selectionStart]) &&
			RegexNumber.test(value[selectionEnd])
		) {
			phoneRef.current && phoneRef.current.setSelectionRange(selectionStart, selectionStart);
			event.preventDefault();
		}
	};
	const handleSerialModal = () => {
		setSerialModalOpen(true);
	};
	const handleSubmit = (event: any) => {
		event.preventDefault();
		isUserInfoUpdated = false;
		const isEmailValid = checkEmailFormat(contactInformationForm.email);
		const isContactFormValid = {
			firstname: false,
			lastname: false,
			email: false,
			phoneno: false,
			modelOrSerialNumber: false,
			modelNumber: false,
			serialNumber: false,
			notes: false
		};
		const contactInfoErrorMessage = {
			firstName: '',
			lastName: '',
			email: '',
			phoneNo: '',
			modelOrSerialNumber: '',
			modelNumber: '',
			serialNumber: '',
			notes: ''
		};
		const requiredFieldMessage = 'This is a required field.';
		const invalidEmailFormat = 'Please enter a valid email address.';
		const invalidPhoneNumber = 'Enter valid phone number.';

		if (!contactInformationForm.firstName.trim()) {
			contactInfoErrorMessage.firstName = requiredFieldMessage;
			isContactFormValid.firstname = true;
		}
		if (!contactInformationForm.lastName.trim()) {
			contactInfoErrorMessage.lastName = requiredFieldMessage;
			isContactFormValid.lastname = true;
		}
		if (!labelOptional && !contactInformationForm.email) {
			contactInfoErrorMessage.email = requiredFieldMessage;
			isContactFormValid.email = true;
		}
		if (contactInformationForm.email && !isEmailValid) {
			contactInfoErrorMessage.email = invalidEmailFormat;
		}
		if (contactInformationForm.email && !isEmailValid) {
			contactInfoErrorMessage.email = invalidEmailFormat;
			isContactFormValid.email = true;
		}
		if (!contactInformationForm.phoneNo) {
			contactInfoErrorMessage.phoneNo = requiredFieldMessage;
			isContactFormValid.phoneno = true;
		}
		if (contactInformationForm.phoneNo && contactInformationForm.phoneNo.length < 14) {
			contactInfoErrorMessage.phoneNo = invalidPhoneNumber;
			isContactFormValid.phoneno = true;
		}
		if (!contactInformationForm.modelNumber) {
			contactInfoErrorMessage.modelNumber = requiredFieldMessage;
			isContactFormValid.modelNumber = false;
		}
		if (!contactInformationForm.serialNumber) {
			contactInfoErrorMessage.serialNumber = requiredFieldMessage;
			isContactFormValid.serialNumber = false;
		}
		if (props.serialNumberShow && !contactInformationForm.modelOrSerialNumber.trim()) {
			contactInfoErrorMessage.modelOrSerialNumber = requiredFieldMessage;
			isContactFormValid.modelOrSerialNumber = true;
		}
		if (!contactInformationForm.notes.trim()) {
			contactInfoErrorMessage.notes = requiredFieldMessage;
			isContactFormValid.notes = true;
		}
		setFormErrorMessages(contactInfoErrorMessage);
		const setFocus: any = Object.entries(isContactFormValid).find(([key, isFieldValid]) => {
			return isFieldValid === true;
		});
		if (setFocus) {
			setFocusToInput(setFocus[0]);
		} else {
			initiateSupportReq();
		}
	};
	const setFocusToInput = (setFocus: any) => {
		if (setFocus === 'firstname' && firstNameRef.current) {
			firstNameRef.current.focus();
		} else if (setFocus === 'lastname' && lastNameRef.current) {
			lastNameRef.current.focus();
		} else if (setFocus === 'phoneno' && phoneRef.current) {
			phoneRef.current.focus();
		} else if (setFocus === 'email' && emailRef.current) {
			emailRef.current.focus();
		} else if (setFocus === 'modelOrSerialNumber' && modelOrSerialNumberRef.current) {
			modelOrSerialNumberRef.current.focus();
		} else if (setFocus === 'notes' && notesRef.current) {
			notesRef.current.focus();
		}
	};
	const initiateSupportReq = () => {
		if (isSetUpdateMyAccount) {
			updateUserAccountInfo();
		} else {
			chatNowText ? handleSFChat() : callUpdateUserService();
		}
	};
	const updateUserAccountInfo = () => {
		setIsSpinnerLoading(true);
		requestRedwolfService(authAPI.getEmailPreference(token))
			.then((response: any) => {
				const updateUserInfo = {
					firstName: contactInformationForm.firstName,
					lastName: contactInformationForm.lastName,
					email: contactInformationForm.email ? contactInformationForm.email : null,
					emailOptin: response.data.emailOptin,
					postalCode: user.postalCode,
					phoneNumber: contactInformationForm.phoneNo
				};
				customerDataUpdate(updateUserInfo);
			})
			.catch((err: any) => {
				setIsSpinnerLoading(false);
				showTechnicalErrorMessage();
				Sentry.captureException(err);
			});
	};

	const callUpdateUserService = () => {
		setIsSpinnerLoading(true);
		const phoneNumber = contactInformationForm.phoneNo;
		const firstName = contactInformationForm.firstName;
		const lastName = contactInformationForm.lastName;
		const email = contactInformationForm.email ? contactInformationForm.email : null;
		let modelNumber = props.isModalDeviceModalNumber ? props.isModalDeviceModalNumber : null;
		let serialNumber = props.isModalDeviceSerialNumber ? props.isModalDeviceSerialNumber : null;
		const notes = contactInformationForm.notes ? contactInformationForm.notes : null;
		const modelOrSerialNumber = contactInformationForm.modelOrSerialNumber
			? contactInformationForm.modelOrSerialNumber
			: null;
		const callCustomerBack = true;

		if (!serialNumber && !modelNumber && modelOrSerialNumber) {
			modelOrSerialNumber.length >= 14
				? (serialNumber = modelOrSerialNumber)
				: (modelNumber = modelOrSerialNumber);
		}
		requestRedwolfService(
			customerSupportAPI.createSupportCase(
				phoneNumber,
				firstName,
				lastName,
				email,
				modelNumber,
				serialNumber,
				notes,
				callCustomerBack
			)
		)
			.then((response: any) => {
				setIsSpinnerLoading(false);
				if (response.constructor.$metadata$.simpleName === 'Success' && response.data) {
					logGoogleAnalyticsEvent('VizioSupport_Textme');
					setSupportCallMeModalOpen(false);
					setContactInformationForm({
						firstName: user && user.firstName,
						lastName: user && user.lastName,
						email: user && user.email && user.email !== 'null' ? user.email : '',
						phoneNo: reformatPhoneNumber && reformatPhoneNumber,
						modelOrSerialNumber: '',
						modelNumber: '',
						serialNumber: '',
						notes: ''
					});

					setISSetUpdateMyAccount(false);
					setSuccessModalOpen(true);
				} else {
					setIsSpinnerLoading(false);
					dispatch(
						openNotification({
							type: 'ERROR',
							heading: 'Error',
							body: response.response.detail
						})
					);
					Sentry.captureException(new Error(`updateContactInformation: ${response}`));
				}
			})
			.catch((err: any) => {
				setIsSpinnerLoading(false);
				showTechnicalErrorMessage();
				Sentry.captureException(err);
			});
	};

	const customerDataUpdate = (updateUserInfo: any) => {
		requestRedwolfService(authAPI.updateUser(token, updateUserInfo))
			.then((response: any) => {
				setIsSpinnerLoading(false);
				if (response.constructor.$metadata$.simpleName === 'Success' && response.data) {
					const responseData = response.data;
					//TODO:(1) Review requiresCreateUser - Its not part of the accountAPI.login
					const updatedUserProfile: UserProfile = {
						firstName: responseData.firstName,
						lastName: responseData.lastName,
						email: responseData.email,
						userId: responseData.userId,
						signInType: userProfile.signInType,
						requiresCreateUser: false,
						isUserLoggedIn: true,
						emailVerified: responseData.emailVerified,
						requiresEmailVerification: responseData.requiresEmailVerification,
						requiresPersonalization: responseData.requiresPersonalization
					};
					dispatch(setUserProfile({ userProfile: updatedUserProfile, user: responseData }));
					dispatch(
						openNotification({
							type: 'SUCCESS',
							heading: 'Success',
							body: notification.message.contactInfoSuccess
						})
					);
					isUserInfoUpdated = true;
				} else {
					dispatch(
						openNotification({
							type: 'ERROR',
							heading: 'Error',
							body: notification.message.contactInfoError
						})
					);
					Sentry.captureException(new Error(`updateContactInformation: ${response}`));
				}
				chatNowText ? handleSFChat() : callUpdateUserService();
			})
			.catch((err: any) => {
				setIsSpinnerLoading(false);
				showTechnicalErrorMessage();
				Sentry.captureException(err);
			});
	};

	const handleSFChat = () => {
		setIsSpinnerLoading(true);
		setSupportCallMeModalOpen(false);
		setSupportTextMeModalOpen(false);
		setModelNumberShow(true);
		logGoogleAnalyticsEvent('VizioSupport_Chatnow');
		const preChatInfo: sfPreChatData = {
			firstName: contactInformationForm.firstName,
			lastName: contactInformationForm.lastName,
			email: contactInformationForm.email,
			notes: contactInformationForm.notes,
			phoneNum: contactInformationForm.phoneNo,
			serialNum: props.isModalDeviceSerialNumber
				? props.isModalDeviceSerialNumber
				: contactInformationForm.modelOrSerialNumber?.length >= 14
				? contactInformationForm.modelOrSerialNumber
				: null,
			modelNum: props.isModalDeviceModalNumber
				? props.isModalDeviceModalNumber
				: contactInformationForm.modelOrSerialNumber?.length < 14
				? contactInformationForm.modelOrSerialNumber
				: null,
			isInfoUpdated: isUserInfoUpdated
		};
		initiateSupportChat(preChatInfo);
		setTimeout(() => {
			setIsSpinnerLoading(false);
		}, 2000);
	};
	const handleSupportTextMeModalHide = () => {
		setSupportCallMeModalOpen(false);
		setSupportTextMeModalOpen(false);
	};
	if (firstNameRef.current && firstNameRef.current.value) {
		firstNameRef.current.classList.add('active');
	}
	if (lastNameRef.current && lastNameRef.current.value) {
		lastNameRef.current.classList.add('active');
	}
	if (emailRef.current && emailRef.current.value) {
		emailRef.current.classList.add('active');
	}
	if (phoneRef.current && phoneRef.current.value) {
		phoneRef.current.classList.add('active');
	}
	if (modelOrSerialNumberRef.current && modelOrSerialNumberRef.current.value) {
		modelOrSerialNumberRef.current.classList.add('active');
	} else if (modelOrSerialNumberRef.current) {
		modelOrSerialNumberRef.current.classList.remove('active');
	}
	if (notesRef.current && notesRef.current.value) {
		notesRef.current.classList.add('active');
	} else if (notesRef.current) {
		notesRef.current.classList.remove('active');
	}
	const handleSuccessModalHide = () => {
		setSuccessModalOpen(false);
		setSupportCallMeModalOpen(false);
	};
	const handleSerialNumberModalHide = () => {
		setSerialModalOpen(false);
	};

	return (
		<div>
			<Modal
				containerClasses="support-modal"
				show={props.isWebSupportModalOpen ? props.isWebSupportModalOpen : props.modalVisible}
				onHide={props.closeModal}
				heading="VIZIO Support">
				<>
					<div className="subhead">
						<p>
							Have VIZIO Support contact you via one of the methods below, or click “Chat Now” to
							chat with one of our representatives.
						</p>
					</div>
					<div className="support-buttons">
						<div className="form-field">
							<button
								type="submit"
								onClick={handleCallMeModalOpen}
								className="secondary-button"
								id="callMeButton"
								aria-label="Call Me">
								Call Me
							</button>
						</div>
						<div className="form-field">
							<button
								type="submit"
								onClick={handleTextMeModalOpen}
								className="secondary-button textMeButton"
								id="textMeButton"
								aria-label="Send a Text">
								Send a Text
							</button>
						</div>
						<div className="form-field">
							<button
								type="submit"
								onClick={handleChatModalOpen}
								className="secondary-button chartNowButton"
								id="chartNowButton"
								disabled={isSupportOffline}
								aria-label="Chat Now">
								Chat Now
							</button>
						</div>
						{supportHours && isSupportOffline && (
							<div className="chat-unavailable-info">
								<p className="chat-info">Chat is currently unavailable.</p>
								<p className="chat-info">
									Chat is available everyday from {supportHours.chatWeekdayBegin} -{' '}
									{supportHours.chatWeekdayEnd} {supportHours.timeZone}
								</p>
							</div>
						)}
					</div>
					{supportHours ? (
						<div className="subheadbottom">
							<div className="sub_heading_info">Call us Toll-Free</div>
							<p className="sub_info">
								Monday - Friday, {supportHours.phoneWeekdayBegin} - {supportHours.phoneWeekdayEnd}{' '}
								{supportHours.timeZone}{' '}
							</p>
							<p>
								Saturday - Sunday, {supportHours.phoneWeekendBegin} - {supportHours.phoneWeekendEnd}{' '}
								{supportHours.timeZone}
							</p>
							<p className="sub_info_time">{supportHours.waitTimeMessage}</p>
							<div className="sub_heading_info">
								Call us at: {!isMobileView && <span>{supportHours.phoneNumberEnglish}</span>}
								{isMobileView && (
									<a href={`tel:${supportHours.phoneNumberEnglish}`} className="link">
										{supportHours.phoneNumberEnglish}
									</a>
								)}
							</div>
						</div>
					) : (
						<div className="subheadbottom">
							<div className="sub_heading_info">
								Support Hours are currently unavailable, please try again later
							</div>
						</div>
					)}
					{isSpinnerLoading && <Spinner />}
				</>
			</Modal>
			{/* Support Call Me Modal */}
			<Modal
				containerClasses="contact-info-modal support-modal"
				show={supportCallMeModalOpen}
				onHide={handleSupportCallMeModalHide}
				heading="VIZIO Support">
				<>
					<form id="supportfoModal" ref={supportContainerFocusRef} {...supportTabindex}>
						<div className="form-field form-field-group">
							<div className={`field half-filed ${formErrorMessages.firstName && 'has-error'}`}>
								<div className="input-box form-group input-label">
									<input
										type="text"
										className="form-control"
										name="firstName"
										id="edit-firstname"
										aria-required="true"
										aria-describedby="fName-req"
										spellCheck="false"
										value={contactInformationForm.firstName}
										onChange={handleChange}
										onKeyDown={handleKeyDown}
										ref={firstNameRef}
									/>
									<label htmlFor="edit-firstname" className="control-label">
										First Name
									</label>

									<code id="fName-req">{formErrorMessages.firstName}</code>
								</div>
							</div>

							<div className={`field half-filed ${formErrorMessages.lastName && 'has-error'}`}>
								<div className="input-box form-group input-label">
									<input
										type="text"
										className="form-control"
										name="lastName"
										id="edit-lastname"
										aria-required="true"
										aria-describedby="lName-req"
										spellCheck="false"
										value={contactInformationForm.lastName}
										onChange={handleChange}
										onKeyDown={handleKeyDown}
										ref={lastNameRef}
									/>
									<label htmlFor="edit-lastname" className="control-label">
										Last Name
									</label>

									<code id="lName-req">{formErrorMessages.lastName}</code>
								</div>
							</div>
						</div>

						<div className="form-field form-field-group">
							<div className={`field half-filed ${formErrorMessages.phoneNo && 'has-error'}`}>
								<div className="input-box form-group input-label">
									<input
										type="text"
										className="form-control"
										name="phoneNo"
										id="edit-phone-no"
										aria-describedby="phone-no-req"
										value={contactInformationForm.phoneNo}
										onChange={handleChange}
										onKeyDown={handleKeyDown}
										maxLength={14}
										ref={phoneRef}
									/>
									<label htmlFor="edit-phone-no" className="control-label">
										Phone Number
									</label>

									<code id="phone-no-req">{formErrorMessages.phoneNo}</code>
								</div>
							</div>
							<div className={`field half-filed ${formErrorMessages.email && 'has-error'}`}>
								<div className="input-box form-group disable input-label">
									<input
										type="text"
										className="form-control"
										name="email"
										id="edit-email"
										aria-required="true"
										autoComplete="email"
										aria-describedby="email-required"
										aria-invalid="false"
										spellCheck="false"
										value={contactInformationForm.email}
										onChange={handleChange}
										ref={emailRef}
										readOnly
										aria-disabled
									/>
									<label htmlFor="edit-email" className="control-label">
										Email Address
									</label>

									<code id="email-required">{formErrorMessages.email}</code>
								</div>
							</div>
						</div>
						<div className={`field half-filed`}>
							<div className="form-checkbox CheckBox">
								<input
									type="checkbox"
									id="update-my-account"
									autoComplete="off"
									checked={isSetUpdateMyAccount}
									aria-labelledby="update-check"
									onChange={(event) => setISSetUpdateMyAccount(event.target.checked)}
								/>
								<label htmlFor="update-my-account" id="update-check">
									Update my VIZIO Account information
								</label>
							</div>
						</div>
						{props.serialNumberShow &&
							!props.isModalDeviceModalNumber &&
							!props.isModalDeviceSerialNumber && (
								<div className="contact_info_details">
									To better assist you, VIZIO will need to know the model or serial number of the
									unit you need support for.
									<a
										href="javascript:void(0)"
										tabIndex={0}
										role="link"
										id="click-contact"
										className="contact_info_click"
										onClick={handleSerialModal}
										aria-labelledby="click-contact contact-info-desc">
										Click here
									</a>
									<span id="contact-info-desc">
										to learn how to locate your model or serial number.
									</span>
								</div>
							)}

						<div className="sn_mn_info">
							{modelNumberShow && props.isModalDeviceModalNumber && (
								<div className="sub_heading_info">
									<span>Model Number:</span> {props.isModalDeviceModalNumber}
								</div>
							)}
							{modelNumberShow && props.isModalDeviceSerialNumber && (
								<div className="sub_heading_info">
									<span>Serial Number:</span> {props.isModalDeviceSerialNumber}
								</div>
							)}
						</div>
						<div
							className={`form-field ${props.serialNumberShow ? '' : modelOrSerialNumberDisplay}`}>
							<div className={`field ${formErrorMessages.modelOrSerialNumber && 'has-error'}`}>
								<div className="input-box form-group input-label serialno">
									<input
										type="text"
										name="modelOrSerialNumber"
										className="form-control"
										aria-required="true"
										id="model-or-serial-number"
										aria-describedby="model-or-serial-number-req"
										onChange={handleChange}
										value={contactInformationForm.modelOrSerialNumber}
										ref={modelOrSerialNumberRef}
										onKeyDown={handleKeyDown}
										maxLength={17}
									/>
									<label htmlFor="model-or-serial-number" className="control-label">
										Model or Serial Number
									</label>
									<code id="model-or-serial-number-req">
										{formErrorMessages.modelOrSerialNumber}
									</code>
								</div>
							</div>
						</div>
						<div className="form-field support-textarea">
							<div className={`field ${formErrorMessages.notes && 'has-error'}`}>
								<div className="input-box form-group input-label">
									<textarea
										name="notes"
										className="form-control"
										id="notes"
										aria-describedby="notes-req"
										aria-required="true"
										rows={4}
										cols={40}
										onChange={handleChange}
										onKeyDown={handleKeyDown}
										ref={notesRef}
										value={contactInformationForm.notes}
									/>
									<label htmlFor="notes" className="control-label">
										How can we help?
									</label>
									<code id="notes-req">{formErrorMessages.notes}</code>
								</div>
							</div>
						</div>
						<div className="form-field content-right">
							<button
								type="submit"
								onClick={handleSubmit}
								className="primary-button"
								value="Continue">
								Continue
							</button>
						</div>
					</form>
					{isSpinnerLoading && <Spinner />}
				</>
			</Modal>
			{/* Support Text Me Modal */}
			<Modal
				containerClasses="support-modal"
				show={supportTextMeModalOpen}
				onHide={handleSupportTextMeModalHide}
				heading="Text VIZIO Support">
				<>
					<div className="text-support-info">
						Using your mobile device, text a brief description of your problem to:
						{supportHours && supportHours.smsNumber ? (
							<div className="support_call_no">{supportHours.smsNumber}</div>
						) : (
							<div className="support_call_no">
								Phone number not available, please try again later
							</div>
						)}
						<div>
							This number accepts SMS/MMS messages only.
							<span className="no_call">
								<span>No voice calls accepted.</span> Message and data rates may apply.
							</span>
						</div>
					</div>
					{isSpinnerLoading && <Spinner />}
				</>
			</Modal>
			<Modal
				containerClasses="support-modal confirm-modal"
				show={successModalOpen}
				onHide={handleSuccessModalHide}
				heading="VIZIO Support">
				<>
					<div className="subheadbottom">
						{callMeText && (
							<p className="support-thanks-info">
								Thank you! The next available agent will call you at the number provided.
							</p>
						)}
						{chatNowText && (
							<p className="support-thanks-info">
								Thank you! You will be redirected to VIZIO Support chat.
							</p>
						)}
					</div>

					<div className="form-field content-right">
						<button
							type="submit"
							onClick={handleSuccessModalHide}
							className="primary-button"
							id="chartNowButton"
							aria-label="Ok">
							Ok
						</button>
					</div>
					{isSpinnerLoading && <Spinner />}
				</>
			</Modal>
			<Modal
				containerClasses="support-modal serial-no-modal"
				show={serialModalOpen}
				onHide={handleSerialNumberModalHide}
				heading="How to Find Your Serial Number">
				<>
					<div className="sub-tittle">
						The serial number can be found on the back of the TV, on the side of the box and
						sometimes on the receipt.
					</div>
					<img src="images/find-serial.png" alt="Find a Serial No" />

					{isSpinnerLoading && <Spinner />}
				</>
			</Modal>
		</div>
	);
};

export default WebSupport;
